const DoorTypesMarquee = () => {
  const doorTypes = ["Up & Over", "Roller Door", "Side Hinge", "Sectional"];
  
  return (
    <section className="py-6 bg-foreground overflow-hidden">
      <div className="relative flex overflow-hidden">
        <div className="animate-marquee flex whitespace-nowrap">
          {[...Array(3)].map((_, setIndex) => (
            doorTypes.map((type, index) => (
              <span 
                key={`${setIndex}-${index}`} 
                className="mx-8 text-xl md:text-2xl font-semibold text-background flex items-center gap-4"
              >
                <span className="text-accent">〰️</span>
                {type}
              </span>
            ))
          ))}
        </div>
        <div className="animate-marquee2 flex whitespace-nowrap absolute top-0">
          {[...Array(3)].map((_, setIndex) => (
            doorTypes.map((type, index) => (
              <span 
                key={`${setIndex}-${index}`} 
                className="mx-8 text-xl md:text-2xl font-semibold text-background flex items-center gap-4"
              >
                <span className="text-accent">〰️</span>
                {type}
              </span>
            ))
          ))}
        </div>
      </div>
    </section>
  );
};

export default DoorTypesMarquee;
